module.exports = __webpack_public_path__ + "img/masan.cd3ad733.png";